import React, { useEffect, useState } from "react";
import Popup from "../../../hoc/Popup/Popup";
import {
  ICourt,
  IRehabSummaryItem,
  ISlotHistory,
  ISummaryItem,
} from "../../../types/api";
import { getSlotHistory } from "../../../api/slotHistory/slotHistory";
import { formatDate, formatToIsoDate } from "../../../shared/dateUtils";
import { formatDateToSwedish } from "../../../shared/utility";
import "./RehabSlotHistoryPopup.scss";
import { toast } from "react-toastify";

interface IRehabSlotHistoryPopupProps {
  showPopup: boolean;
  onClose: () => void;
  onConfirm: () => void;
  rehabSlot?: IRehabSummaryItem;
  rehabDate?: Date;
}

function RehabSlotHistoryPopup({
  showPopup,
  onClose,
  rehabSlot,
  rehabDate,
}: IRehabSlotHistoryPopupProps) {
  const [slotHistory, setSlotHistory] = useState<ISlotHistory>();

  const popupDateString = formatDate(
    rehabDate ? rehabDate : new Date(),
    "yyyy-MM-dd"
  );

  const handleClose = () => {
    setSlotHistory(undefined);
    onClose();
  };
  const fetchSlotHistory = async () => {
    if (!rehabSlot || !rehabDate) {
      return;
    }
    const dateString =
      formatDate(rehabDate, "yyyy-MM-dd") + "T" + rehabSlot.start_time;

    try {
      const response = await getSlotHistory("rehab-1891", dateString);
      setSlotHistory(response);
    } catch (error: any) {
      toast.error(`${error}`);
    }
  };

  useEffect(() => {
    if (showPopup) {
      fetchSlotHistory();
    }
  }, [showPopup]);

  // Function to group events by the 'created_at' timestamp
  const groupEventsByCreatedAt = (historyArray: ISlotHistory["history"]) => {
    return historyArray.reduce((acc: Record<string, any[]>, current) => {
      const dateString = current.created_at.replace(/(:\d{2})$/, "");
      if (!acc[dateString]) {
        acc[dateString] = [];
      }
      acc[dateString].push(current);
      return acc;
    }, {});
  };

  const groupedHistory = slotHistory
    ? groupEventsByCreatedAt(slotHistory.history)
    : {};
  const { weekday } = formatDateToSwedish(rehabDate ? rehabDate : new Date());
  return (
    <Popup
      showPopup={showPopup}
      onClose={handleClose}
      leftTopElement={
        <span className="text-m">
          {`Rehab-bad historik för tid: ${rehabSlot?.start_time?.slice(
            0,
            5
          )} ${weekday}en - ${popupDateString}
          `}
        </span>
      }
    >
      {rehabDate && rehabDate < new Date("2025-05-22") ? (
        <div className="slot-history-wrapper text-m">
          Historik var inte implementerat innan den 25 Maj 2025
        </div>
      ) : (
        <div className="slot-history-wrapper text-m">
          {Object.keys(groupedHistory).length === 0 && (
            <div className="slot-history-item">Inga event har hänt</div>
          )}
          {Object.entries(groupedHistory).map(([createdAt, events], index) => {
            const { weekday, dateAndMonth, hour, seconds } =
              formatDateToSwedish(new Date(createdAt));
            const hourString = hour.split(".").join(":");

            return (
              <div key={index} className="slot-history-item">
                <div className="slot-history-blob"> </div>
                <div>
                  {weekday}, {dateAndMonth} - kl. {hourString}:{seconds}
                </div>
                <div className="event-split-wrapper">
                  {events.map((event, eventIndex) => {
                    const eventLines = event.event.split(".");
                    return (
                      <div key={eventIndex} className="event-split-item">
                        {eventLines.map((line: any, lineIndex: any) => {
                          return (
                            <div key={lineIndex} className="event-line">
                              {line}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
                <div>Gjordes av: {events[0].created_by}</div>
              </div>
            );
          })}
        </div>
      )}
    </Popup>
  );
}

export default RehabSlotHistoryPopup;
